import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

const rebootCss = reboot();

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;700;900&family=Ubuntu:wght@300;400&display=swap');
  ${rebootCss}

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .content-wrap {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 10px auto;
  }

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    font-weight: 700;
    border-left: 4px solid #cf1a17;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  .charts-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .chart-wrap {
    position: relative;
    width: 49.9%;
  }

  @media(max-width: 479px) {
    .chart-wrap {
      width: 99.9%;
    }
  }

  h4 {
    padding-left: 50px;
  }

   /* svg styles */
 svg {
    font-weight: 300;
    font-size: 8px;
    font-family: 'Raleway',sans-serif;
    margin-bottom: 40px;
  }
  
  .x-axis,
  .y-axis {
    pointer-events: none;
  }

  .x-axis .domain,
  .axis--x .domain {
    opacity: 0;
  }

  .x-axis line,
  .y-axis line,
  .extra-axis {
    stroke: #999;
    opacity: 0.5;
    
  }

  .y-axis .tick text,
  .x-axis .tick text {
    fill: #777;
    font-family: 'Raleway';
    font-size: 11px;
  }

  footer {
    font-size: 13px;
    height: 30px;
  }


`;
